import { PrivacyPolicyStyled } from "./PrivacyPolicy.styles";

export const PrivacyPolicy = () => {
  return (
    <PrivacyPolicyStyled>
      <h1>Política de Privacidad de Datos de Cash Back Colombia S.A.</h1>
      <p><em>(En cumplimiento de la Ley Estatutaria 1581 de 2012 y sus decretos reglamentarios)</em></p>
      <p><strong>Última actualización: 12 de octubre de 2025</strong></p>

      <h2>1. Introducción</h2>
      <p>
        Cash Back Colombia S.A. (“la Empresa”, “nosotros”) se compromete a proteger su privacidad y sus datos personales.
        Esta política describe cómo recolectamos, usamos, almacenamos y procesamos su información personal de acuerdo con
        los principios y requisitos de la Ley Colombiana 1581 de 2012 (“Habeas Data”) y sus regulaciones complementarias.
        Al utilizar nuestros servicios, usted otorga su autorización previa, expresa e informada para el tratamiento de sus
        datos personales.
      </p>

      <h2>2. Responsable del Tratamiento</h2>
      <p>La entidad responsable del tratamiento de sus datos personales es:</p>
      <ul>
        <li><strong>Razón Social:</strong> Cash Back Colombia S.A.</li>
        <li><strong>NIT:</strong> 901556175-5</li>
        <li><strong>Dirección:</strong> Carrera 16 # 93 - 78, Oficina 301, Bogotá, Colombia</li>
        <li><strong>Correo Electrónico:</strong> <a href="mailto:clay@cashbackplus.ai">clay@cashbackplus.ai</a></li>
      </ul>

      <h2>3. Datos Personales Recolectados</h2>
      <p>
        Recolectamos datos personales que son veraces, completos, exactos y actualizados. Los tipos de datos personales que podemos recolectar incluyen:
      </p>
      <ul>
        <li><strong>Datos de Identificación:</strong> Nombre, número de identificación (Cédula de Ciudadanía o equivalente).</li>
        <li><strong>Datos de Contacto:</strong> Dirección de correo electrónico, número de teléfono y dirección física.</li>
        <li><strong>Datos Financieros:</strong> Número de cuenta bancaria, tipo de cuenta y nombre de la entidad financiera para los pagos de cash back.</li>
        <li><strong>Datos Transaccionales:</strong> Registros de sus compras con nuestros comercios afiliados, incluyendo fecha, hora y valor de la transacción.</li>
        <li><strong>Datos Técnicos:</strong> Dirección IP, información del dispositivo y datos de geolocalización.</li>
      </ul>
      <p>
        No recolectamos ni tratamos datos personales sensibles (por ejemplo, origen racial o étnico, opiniones políticas,
        convicciones religiosas), a menos que sea legalmente requerido o con su consentimiento explícito y separado.
      </p>

      <h2>4. Finalidad del Tratamiento de Datos</h2>
      <p>Trataremos sus datos personales para los siguientes fines legítimos:</p>
      <ul>
        <li><strong>Prestación del Servicio:</strong> Para proveer nuestros servicios de cash back, gestionar su cuenta y cumplir con nuestras obligaciones contractuales.</li>
        <li><strong>Gestión de Transacciones:</strong> Para rastrear sus compras con los comercios afiliados y calcular el monto de cash back que le corresponde.</li>
        <li><strong>Pagos:</strong> Para procesar y transferir el cash back obtenido a su cuenta bancaria designada.</li>
        <li><strong>Marketing y Comunicaciones:</strong> Para enviarle información sobre nuevas ofertas, promociones y servicios, sujeto a su consentimiento previo.</li>
        <li><strong>Servicio al Cliente:</strong> Para responder a sus consultas, quejas y solicitudes.</li>
        <li><strong>Cumplimiento Legal:</strong> Para cumplir con obligaciones legales y regulatorias, incluida la prevención del fraude y la elaboración de informes.</li>
        <li><strong>Análisis:</strong> Para analizar el comportamiento de los usuarios con el fin de mejorar nuestros servicios y estrategias de marketing.</li>
      </ul>

      <h2>5. Derechos del Titular de los Datos</h2>
      <p>Como titular de sus datos personales, usted tiene los siguientes derechos bajo la Ley 1581 de 2012:</p>
      <ul>
        <li><strong>Derecho de Acceso:</strong> A conocer qué datos personales hemos recolectado sobre usted y la finalidad de su uso.</li>
        <li><strong>Derecho de Actualización y Rectificación:</strong> A actualizar o corregir cualquier dato personal incompleto, inexacto o desactualizado.</li>
        <li><strong>Derecho a Ser Informado:</strong> A ser informado, previa solicitud, sobre el uso que se le ha dado a sus datos personales.</li>
        <li><strong>Derecho de Revocación del Consentimiento:</strong> A revocar su consentimiento para el tratamiento de sus datos personales en cualquier momento, salvo que una obligación legal o contractual lo impida.</li>
        <li><strong>Derecho de Supresión:</strong> A solicitar la eliminación de sus datos personales cuando el tratamiento no respete los principios constitucionales y legales.</li>
        <li><strong>Derecho a Presentar Quejas:</strong> A presentar una queja ante la Superintendencia de Industria y Comercio (SIC) si considera que se han violado sus derechos.</li>
      </ul>

      <h2>6. Procedimientos para Ejercer Sus Derechos</h2>
      <p>
        Para ejercer sus derechos, puede enviar un correo electrónico a{" "}
        <a href="mailto:dataprivacy@cashbackcolombia.com">dataprivacy@cashbackcolombia.com</a>{" "}
        o una solicitud escrita a Carrera 16 # 93 - 78, Oficina 301, Bogotá, Colombia.
      </p>
      <p>
        Su solicitud debe incluir su nombre, número de identificación y una descripción clara del derecho que desea ejercer.
        Responderemos dentro de los plazos legalmente establecidos.
      </p>

      <h2>7. Seguridad de los Datos</h2>
      <p>
        Implementamos medidas de seguridad técnicas, humanas y administrativas para proteger sus datos personales de accesos
        no autorizados, pérdida, alteración o destrucción. Todo el personal involucrado en el tratamiento de datos está sujeto
        a un estricto deber de confidencialidad.
      </p>

      <h2>8. Transferencia Internacional de Datos</h2>
      <p>
        No transferimos sus datos personales a otros países. Si en el futuro fuera necesario transferir sus datos a un tercer país,
        lo haremos únicamente con su consentimiento explícito y cumpliendo los requisitos de la Ley 1581 de 2012, que exige un nivel
        adecuado de protección de datos.
      </p>

      <h2>9. Vigencia</h2>
      <p>
        Esta política es efectiva a partir de la fecha de su publicación y permanecerá vigente durante todo el tiempo que duren las
        operaciones de la Empresa y mientras las bases de datos estén activas.
      </p>
    </PrivacyPolicyStyled>
  );
};
